export default {
  methods: {
    closeModal () {
      this.$store.commit('errors/setConnectionError', false)
    }
  }
}
